import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "hotel-facilities-grid" }
const _hoisted_2 = { class: "hotel-facilities-grid__left" }
const _hoisted_3 = { class: "hotel-facilities-grid__right" }

import { computed } from 'vue';
import HotelInfoDisclaimer from '@lmt-rpb/Atoms/HotelInfoDisclaimer/HotelInfoDisclaimer.vue';
import type { Attribute } from '@/interfaces/offer-list-types/offer-list-typo-hotel-data';
import HotelFacility from './HotelFacility.vue';
import { chunkArray } from '@/js/utils/arrayUtils';

interface Props {
	attributes: Attribute[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'HotelFacilitiesGrid',
  props: {
    attributes: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;

const chunks = computed(() => chunkArray(props.attributes, 2));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunks.value.at(0), (attribute) => {
        return (_openBlock(), _createBlock(HotelFacility, {
          key: attribute.Name,
          attribute: attribute
        }, null, 8 /* PROPS */, ["attribute"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunks.value.at(1), (attribute) => {
        return (_openBlock(), _createBlock(HotelFacility, {
          key: attribute.Name,
          attribute: attribute
        }, null, 8 /* PROPS */, ["attribute"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode(HotelInfoDisclaimer, { class: "hotel-facilities-grid__legal" })
  ]))
}
}

})